import { render, staticRenderFns } from "./testMembershipAddress.vue?vue&type=template&id=4a568cfe&scoped=true&"
import script from "./testMembershipAddress.vue?vue&type=script&lang=js&"
export * from "./testMembershipAddress.vue?vue&type=script&lang=js&"
import style0 from "./testMembershipAddress.vue?vue&type=style&index=0&id=4a568cfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a568cfe",
  null
  
)

export default component.exports